import { Component,  ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectionType, DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ToastrService } from 'ngx-toastr';
import { InfoMessage} from 'src/app/shared/all-routes';
import { HttpService } from 'src/app/shared/http.service';
import { DateConvertor } from '../../date-convertor';
@Component({
  selector: 'app-clientPayment',
  templateUrl: './clientPayment.component.html',
})
export class ClientPaymentComponent {
  api: string = 'GetClientPaymentBreakdownGridDataTableRows';
  data: any = {};
  columns = [];
  selected = [];
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  selectedRow: any = {};
  updatedRows: any[] = [];
  queryParams: any = {};
  currDate= new Date();
  rows: any[] = [];
  originalData: any[] = [];
  selectedRows: any[] = [];
  tempRows: any[] = [];
  count: any;
  currentVisible: number = 5;
  appInfo: any = {};
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(DatatableComponent) pbTable: DatatableComponent | any;
  tableOptions: any = {
    HeaderHeight: '50',
    FooterHeight: '50',
    Limit: '4',
    ColumnMode: 'force',
    RowHeight: 'auto',
  };
  isSaving: boolean = false;
dateConvertor: DateConvertor | any;

isAllSelected: any;
selectedRowsCount: any;
  constructor(private httpService: HttpService,
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    let that = this;
    that.dateConvertor = new DateConvertor();
    that.data.ClientPaymentDate = that.currDate;
    that.appInfo = this.httpService.getAppInfo(-9985);
    that.queryParams = that.route.snapshot.queryParams;
    that.get();
  }
  //api functions

  get() {
    let that = this;
    that.httpService.get(that.api).subscribe((res: any) => {
      that.rows = res.Rows;
      that.data.ClientPaymentDate=that.dateConvertor.parseDate(res.ClientPaymentDate?.split(' ')[0]);
      that.tempRows = res.Rows;
    });
  }

  updateFilter(event: any) {
    let that = this;
    const val = event.target.value.toLowerCase();
    that.rows = that.tempRows.filter((row:any) => {
      const searchableFields = [
        'TransactionType',
        'TransactionDescription',
        'ClientReference',
        'Currency',
        'UnderwriterName',
        'ClientName',
        'MarketType',
      ];
      return searchableFields.some(field => row[field]?.toString().toLowerCase().includes(val));
    });
    that.rows = [...that.rows];
    that.pbTable.offset = 0;
  }

  getRowClass(row: any): string {
    if (row.isSelected) {
      return 'row-color';
    } else {
      return '';
    }
  }
     onRowActivate(event: any) {
    if (event.type === 'click') {
      this.toggleRowSelection(event.row);
    }
  }
   toggleRowSelection(row: any) {
    row.isSelected = !row.isSelected;

    this.checkboxSingleRowSelect(row);
  }
  checkboxSingleRowSelect(rowData: any) {
    rowData.isSelected ? this.selectedRows.push(rowData) : this.selectedRows = this.selectedRows.filter(row => row !== rowData);
    this.isAllSelected = this.rows.every(row => row.isSelected);
    this.selectedRowsCount = this.selectedRows.length;
  }
  
  selectAllRows(rowData:any){
    let that = this;
    if(that.isAllSelected === true){
      that.rows.forEach(function(data){
        data['isSelected'] = true;
      });
      that.selectedRows= that.rows;
      that.selectedRowsCount = that.rows.length;
    }else if(that.isAllSelected === false){
      that.rows.forEach(function(data){
        data['isSelected'] = false;
      });
      that.selectedRows= [];
      that.selectedRowsCount = 0;
    }
  }
  select() {
    let that= this;
    let selectedData = {
      rows: that.selectedRows,
      selectedDate: that.data.ClientPaymentDate= that.dateConvertor.dateTimeToDate(that.data.ClientPaymentDate) ? that.data.ClientPaymentDate= that.dateConvertor.dateTimeToDate(that.data.ClientPaymentDate) : that.currDate
    };
    if(that.selectedRows?.length > 0){
      that.activeModal.close(selectedData);
    }else{
      that.toastr.warning(InfoMessage.SelectMessage, "Warning!")
    }
  }

  close() {
    let that = this;
    that.data.ClientPaymentDate = '';
    that.selectedRows = [];
    that.activeModal.close();
  }

  handleChange(event: any) {
    const value = event.target.value;
    const fieldName = event.target.name;

    // Allow empty values
    if (!value || value.trim() === '') {
      return;
    }

    // Strict date validation regex for DD/MM/YYYY format
    const strictDateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;

    if (!strictDateRegex.test(value)) {
      // Invalid format - clear the field immediately
      this.data[fieldName] = "";
      this.toastr.warning('Invalid date format. Please use dd/mm/yyyy', 'Date Validation');
      return;
    }

    // Additional validation: check if it's a real date and year is in valid range
    const parts = value.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    // Validate year range (prevent 0202, 0001, etc.)
    if (year < 1900 || year > 2200) {
      this.data[fieldName] = "";
      this.toastr.warning('Year must be between 1900 and 2200', 'Date Validation');
      return;
    }

    // Validate the actual date (e.g., prevents 31/02/2024)
    const testDate = new Date(year, month - 1, day);
    if (testDate.getDate() !== day || 
        testDate.getMonth() !== month - 1 || 
        testDate.getFullYear() !== year) {
      this.data[fieldName] = "";
      this.toastr.warning('Invalid date. Please check the day, month, and year.', 'Date Validation');
      return;
    }
  }

  onDateValidationError(errorMessage: string) {
    this.toastr.warning(errorMessage, 'Date Validation');
  }
  
}
